function parseCSV(text) {
  const raw = text.replace(/^\uFEFF/, '').trim();
  if (!raw) return null;
  const lines = [];
  let i = 0;
  while (i < raw.length) {
    const row = [];
    while (i < raw.length && raw[i] !== '\n' && raw[i] !== '\r') {
      if (raw[i] === '"') {
        i++;
        let cell = '';
        while (i < raw.length) {
          if (raw[i] === '"') {
            i++;
            if (raw[i] === '"') {
              cell += '"';
              i++;
            } else break;
          } else {
            cell += raw[i++];
          }
        }
        row.push(cell);
        if (raw[i] === ',') i++;
      } else {
        let cell = '';
        while (i < raw.length && raw[i] !== ',' && raw[i] !== '\n' && raw[i] !== '\r') {
          cell += raw[i++];
        }
        row.push(cell.replace(/^"|"$/g, '').replace(/""/g, '"'));
        if (raw[i] === ',') i++;
      }
    }
    if (row.some((c) => c.trim() !== '')) lines.push(row);
    if (raw[i] === '\r') i++;
    if (raw[i] === '\n') i++;
  }
  if (lines.length < 2) return null;
  const headers = lines[0].map((h) => h.trim().toLowerCase().replace(/\s+/g, '_'));
  const headerMap = {};
  headers.forEach((h, idx) => {
    headerMap[h] = idx;
    const alt = h.replace(/_/g, '');
    if (!headerMap[alt]) headerMap[alt] = idx;
  });
  const getCol = (row, ...names) => {
    for (const n of names) {
      const idx = headerMap[n?.toLowerCase?.() || n];
      if (idx != null && row[idx] !== undefined && row[idx] !== null) {
        const v = String(row[idx]).trim();
        return v || '';
      }
    }
    return '';
  };
  const items = [];
  for (let r = 1; r < lines.length; r++) {
    const row = lines[r];
    const doctor_name = getCol(row, 'doctor_name', 'doctorname', 'primary_name', 'name');
    let service_provided = getCol(row, 'service_provided', 'serviceprovided', 'services');
    if (!service_provided) continue;
    items.push({ doctor_name, service_provided });
  }
  return items.length > 0 ? items : null;
}

function parseJSON(json) {
  if (Array.isArray(json)) {
    return json.map((row) => {
      const doctor_name = row.doctor_name || row.primary_name || row.name || '';
      let service_provided = row.service_provided;
      if (Array.isArray(row.services)) {
        service_provided = row.services.join('; ');
      }
      service_provided = service_provided || '';
      return { doctor_name, service_provided };
    }).filter((x) => x.doctor_name && x.service_provided);
  }
  if (json?.items && Array.isArray(json.items)) {
    return parseJSON(json.items);
  }
  return null;
}

export function parseInput(text) {
  const trimmed = text.trim();
  if (!trimmed) return null;
  try {
    const json = JSON.parse(trimmed);
    const parsed = parseJSON(json);
    if (parsed) return parsed;
  } catch {
    // not JSON
  }
  const csv = parseCSV(trimmed);
  return csv;
}
